'use strict';
/*
 * Return type based on file extension
 * */
export default function FileTypeFilter() {
  'ngInject';

  return function (fileExtension: string = '') {
    let fileType = '';

    switch (fileExtension) {
      case 'xls':
      case 'xlsx':
        fileType = 'excel';
        break;

      case 'doc':
      case 'docx':
        fileType = 'docx';
        break;

      // for these we simply let the extension be the type
      case 'pdf':
      case 'csv':
        fileType = fileExtension;
        break;

      default:
        fileType = 'unknown';
    }

    return fileType;
  };
}
